import styled from 'styled-components';
import {alignCenter, alignEnd, dFlex, dFlexColumn, justifyCenter} from '../../../../globalVariables/GlobalFlex';

export const row = styled.div`
    ${dFlex}
    ${alignEnd}
    ${justifyCenter}
    gap: var(--space-2xl);
    direction: rtl;
    width: 100%;
`;

export const col = styled.span`
    ${dFlexColumn}
    ${alignEnd}
    gap: var(--space-xs);
    direction: ltr;
`;

export const colLabel = styled.span`
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-regular);
    line-height: 1.2;
    color: var(--color-text-default);
`;

export const colValue = styled.span`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-sm);
    direction: ltr;
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-regular);
    line-height: 1.2;
`;

export const iconWrap = styled.span`
    ${dFlex}
    width: 18px;
    height: 18px;
    flex: none;
`;
